import { useContext, useCallback } from 'react';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { getCampaignStatus, getCampaignStatusPromise } from '@bingads-webui-campaign-react/pmax-overview-data';

export const useReadCampaign = ({ set }) => {
  const { scope } = useContext(ScopeContext) as any;
  const {
    cid, aid, campaignId,
  } = scope.values;

  return useCallback(() => getCampaignStatus({
    cid, aid, campaignId, set,
  }), [aid, campaignId, cid, set]);
};

export const useReadCampaignPromise = () => {
  const { scope } = useContext(ScopeContext) as any;
  const {
    cid, aid, campaignId,
  } = scope.values;

  return useCallback(() => getCampaignStatusPromise({ cid, aid, campaignId }), [aid, campaignId, cid]);
};
